import React, { Component } from 'react'
import { Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import TaxDisplayNameItem from './TaxDisplayNameItem'

const TaxDisplayNameItemEditable = EditableHOCWrapper(TaxDisplayNameItem)

class TaxDisplayNames extends Component {
  onSave = (index) => (data, afterSave) => {
    this.props.onSave(index, data, afterSave)
  }

  render() {
    const {
      taxDisplayNames = [],
      lastModifiedDisplayNames,
      companyFeatures = {},
      taxTypeMapping = false,
      taxTypeOptions = [],
    } = this.props

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Tax Name </TableCell>
            <TableCell>Display Name</TableCell>
            {companyFeatures.enableAppendTax ? (
              <TableCell>Append "Tax" to all tax names</TableCell>
            ) : null}
            {taxTypeMapping ? <TableCell>Tax Type</TableCell> : null}
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {taxDisplayNames && taxDisplayNames.length
            ? taxDisplayNames.map((item, i) => {
                return (
                  <TaxDisplayNameItemEditable
                    key={i}
                    dataToEdit={item}
                    onSave={this.onSave(i)}
                    lastModified={lastModifiedDisplayNames}
                    companyFeatures={companyFeatures}
                    taxTypeMapping={taxTypeMapping}
                    taxTypeOptions={taxTypeOptions}
                  />
                )
              })
            : null}
        </TableBody>
      </Table>
    )
  }
}

export default TaxDisplayNames



// WEBPACK FOOTER //
// ./src/components/TaxOption/TaxDisplayNames.js